export default class Single{

    constructor(){
        this.init();
    }


    init(){
        if($('.single').length == 0) return;
        this.changeTextAreaHeight();
    }

    /**
     * formのTextAreaの高さを自動調整
     */
    changeTextAreaHeight(){
        if($('.js-textArea').length == 0) return;
        
        $('.js-textArea').each((index, element)=>{
            const $target = $(element);

            $target.on('change keyup keydown paste cut', function(e){
                if($(this).outerHeight() > this.scrollHeight){
                    $(this).height(1);
                }

                while ($(this).outerHeight() < this.scrollHeight){
                    $(this).height($(this).height() + 1)
                }
            });
        });
    }
}